import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IonRouterOutlet } from '@ionic/angular/standalone';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [CommonModule, IonRouterOutlet],
})
export class AppComponent {}
